import { all, fork } from 'redux-saga/effects';

import watchAddCreditCard from './addCreditCard';
import watchClearCreditCards from './clearCreditCards';
import watchGetBalancePending from './getBalancePending';
import watchGetInstallment from './getInstallment';
import watchRemoveCreditCard from './removeCreditCard';
import watchUpdateCreditCard from './updateCreditCard';
import watchValidateCreditCard from './validateCreditCard';

function* creditCardSagas() {
  yield all([
    fork(watchAddCreditCard),
    fork(watchUpdateCreditCard),
    fork(watchRemoveCreditCard),
    fork(watchGetBalancePending),
    fork(watchValidateCreditCard),
    fork(watchClearCreditCards),
    fork(watchGetInstallment),
  ]);
}

export default creditCardSagas;
